module.exports = __webpack_public_path__ + "img/sushitataroverview.19b71c61.jpg";